import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class BettingLimitConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getBetLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.betLimit,
			"v1/currentcustomerlimits/betlimit"
		);
	}

	getTimedWageringLimitUpdateEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.timedWageringLimit,
			"v1/currentcustomerlimits/betlimit/wageringlimit"
		);
	}

	getNetlossLimitUpdateEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.netlossLimit,
			"v1/currentcustomerlimits/betlimit/netlossLimit"
		);
	}

	getBetCountLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.bettingLimit,
			"v1/lv/currentcustomerlimits/betlimit"
		);
	}

	getBetSizeLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.bettingSizeLimit,
			"v1/lv/currentcustomerlimits/betsizelimit"
		);
	}

	getWageringLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.wageringLimit,
			"v1/lv/currentcustomerlimits/wageringlimit"
		);
	}

	getRemainingBetLimitEndPoint(): string {
		return this.configService.get(
			(x) => x.common.responsibleGaming.endpoints!.remainingBetLimit,
			"v1/currentcustomerlimits/betlimit/remaining"
		);
	}

	getResetNetlossDoNotShowAgainBtnState(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.resetNetlossDoNotShowAgainBtnState, false);
	}
}
